import { Step } from 'react-joyride'
import { Reducer } from 'redux'
import { tour as commonTourReducer } from '~/store/tour/reducer'
import { ActionTypes, TOUR_ACTIONS } from './types'

const initialState = {
  currentStepIndex: 0,
  isTourRunning: false,
  steps: [],
}

type State = {
  currentStepIndex: number
  isTourRunning: boolean
  steps: Step[]
}

export const tour: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case TOUR_ACTIONS.SET_CURRENT_STEP_INDEX: {
      return {
        ...state,
        currentStepIndex: action.currentStepIndex,
      }
    }

    case TOUR_ACTIONS.SET_IS_TOUR_RUNNING: {
      return {
        ...state,
        isTourRunning: action.isTourRunning,
      }
    }

    default:
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any
      return (commonTourReducer(state as any, action as any) as unknown) as State
  }
}
